import {
    Component, OnInit, ElementRef, AfterViewInit, ViewChild, Renderer2
} from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
    PoPageModule,
    PoInfoModule,
    PoButtonModule,
    PoDividerModule,
    PoIconModule,
    PoFieldModule,
    PoLoadingModule,
    PoInfoOrientation,
    PoInputComponent,
    PoModalModule,
    PoModalComponent,
    PoDialogModule,
    PoDialogService
} from '@po-ui/ng-components';
import { FormsModule } from '@angular/forms';
import { ToasterComponent } from '../../../shared/components/toaster/toaster.component';
import { ProductionOrderService } from '../../../shared/service/production-order.service';
import { TokenService } from '../../../shared/service/token.service';
import { ToasterService } from '../../../shared/service/toaster.service';
import { CountService } from '../../../shared/service/count.service';

@Component({
    standalone: true,
    selector: 'app-count-items',
    templateUrl: './count-items.component.html',
    styleUrls: ['./count-items.component.css'],
    imports: [
        CommonModule,
        PoPageModule,
        PoInfoModule,
        PoButtonModule,
        PoDividerModule,
        PoIconModule,
        PoFieldModule,
        FormsModule,
        PoLoadingModule,
        ToasterComponent,
        PoModalModule, PoDialogModule
    ]
})
export class CountItemsComponent implements OnInit, AfterViewInit {
    @ViewChild('barcodeInput', { static: true }) barcodeInput!: PoInputComponent;
    @ViewChild('confirmModal') confirmModal!: PoModalComponent;

    isLoading: boolean = false;
    size = 'sm';
    text = 'Carregando';
    PoInfoOrientation = PoInfoOrientation;

    countDetails: any;
    barCode: string = '';
    itemToRemoveSequence: number | null = null;

    constructor(
        private router: Router,
        private productionOrderService: ProductionOrderService,
        private tokenService: TokenService,
        private toasterService: ToasterService,
        private countService: CountService,
        private poDialog: PoDialogService
    ) { }

    ngOnInit(): void {
        this.countDetails = history.state?.countDetails;

        if (!this.countDetails) {
            this.router.navigate(['/count-details']);
        }
        const branchCode = Number(this.tokenService.getBranch());
        this.loadCount(branchCode, this.countDetails.code);
    }

    ngAfterViewInit(): void {
        this.focusInputBarcode();
    }

    private focusInputBarcode(): void {
        this.barcodeInput.focus();
    }

    loadCount(branchCode: number, countCode: number): void {
        this.countService.getCountByCode(branchCode, countCode).subscribe({
            next: (res: any) => {
                this.countDetails.code = res.code;
                this.countDetails.items = res.items.sort((a: any, b: any) => b.sequence - a.sequence);

                this.recalculateCountDetails();
            },
            error: (err: any) => {
                console.error('Erro ao buscar contagem:', err);
            }
        });
    }

    private recalculateCountDetails(): void {
        const items = this.countDetails.items || [];

        this.countDetails.quantity = items.reduce(
            (sum: number, item: any) => sum + (item.quantity || 0),
            0
        );

        const uniquePacks = new Set(
            items
                .map((i: any) => i.pack)
                .filter((p: any) => p !== null && p !== undefined)
        );
        this.countDetails.pack = uniquePacks.size;
    }

    removeItem(sequence: number): void {
        this.itemToRemoveSequence = sequence;

        this.poDialog.confirm({
            title: 'Confirmar exclusão',
            message: 'Deseja realmente excluir este item da contagem?',
            confirm: () => this.confirmRemoveItem(),
        });
    }

    confirmRemoveItem(): void {
        const branchCode = Number(this.tokenService.getBranch());
        const countCode = this.countDetails.code;

        const item = this.countDetails.items.find((i: any) => i.sequence === this.itemToRemoveSequence);
        if (!item) return;

        this.countService.deleteCountItem(branchCode, countCode, item.sequence).subscribe({
            next: () => {
                this.toasterService.triggerAlert('Item removido com sucesso.', 'success');
                this.loadCount(branchCode, countCode);

            },
            error: (err) => {
                this.toasterService.triggerAlert(err?.error?.[0]?.message || 'Erro ao remover item.', 'error');
            },
            complete: () => {
                this.itemToRemoveSequence = null;
            }
        });
    }

    private addItemLocal(newItem: any): void {
        this.countDetails.items.push(newItem);

        this.countDetails.items.sort((a: any, b: any) => b.sequence - a.sequence);

        this.recalculateCountDetails();
    }

    cancelRemoveItem(): void {
        this.itemToRemoveSequence = null;
        this.confirmModal.close();
    }

    goBack(): void {
        const branchCode = Number(this.tokenService.getBranch());
        const countCode = this.countDetails.code;
        this.router.navigate(['/count-details', branchCode, countCode]);
    }

    onScan(): void {
        const barCode = this.barCode.trim();
        if (!barCode) {
            this.toasterService.triggerAlert('Código de barras vazio.', 'warning');
            return;
        }

        const alreadyScanned = this.countDetails.items.some((item: any) => item.barCode === barCode);
        if (alreadyScanned) {
            this.toasterService.triggerAlert('Este código de barras já foi lido na contagem.', 'warning');
            this.barCode = '';
            this.focusInputBarcode();
            return;
        }

        this.isLoading = true;
        const branchCode = Number(this.tokenService.getBranch()!);

        this.productionOrderService.validateBarCode(
            branchCode,
            barCode,
            this.countDetails.originLocation.placeCode,
            this.countDetails.destinationLocation.placeCode,
            null

        ).subscribe({
            next: (res: any) => {
                this.countService.postCountItem(
                    branchCode,
                    this.countDetails.code,
                    res.productCode,
                    barCode,
                    1
                ).subscribe({
                    next: (insertedItem: any) => {
                        this.addItemLocal(insertedItem);
                    },
                    error: (err: any) => {
                        this.toasterService.triggerAlert(err?.error?.[0]?.message || 'Erro ao inserir item.', 'error');
                    }
                });

                this.isLoading = false;
            },
            error: (err: any) => {
                this.toasterService.triggerAlert(err?.error?.[0]?.message || 'Erro na validação.', 'error');
                this.isLoading = false;
            }
        });

        this.barCode = '';
        this.focusInputBarcode();
    }





}
